import { TruncatingList } from "client/Components";
import { ReactElement } from "react";

export type CategoryListProps = {
	categories: readonly string[];
	onVisibleItemCountChange?: (count: number) => void;
	shouldHideCounter?: boolean;
	shouldShowAtLeastOne?: boolean;
};

export const CategoryList = (props: CategoryListProps): ReactElement => {
	const {
		categories,
		onVisibleItemCountChange,
		shouldHideCounter,
		shouldShowAtLeastOne
	} = props;

	return (
		<TruncatingList
			items={categories}
			wrappingBehavior="ellipsis"
			trackingId="category-list"
			maxNumberOfVisibleItems={3}
			onVisibleItemCountChange={onVisibleItemCountChange}
			hiddenCounter={{
				isHidden: shouldHideCounter
			}}
			shouldShowAtLeastOne={shouldShowAtLeastOne}
		>
			{(item: string): ReactElement => (
				<>{item}</>
			)}
		</TruncatingList>
	);
};
CategoryList.displayName = "CategoryList";